import { CheckIcon } from '@braskai/icons';
import { Typography } from '@braskai/ui-kit';

import { SCheckCircle, SOptionRow } from './styled';

type Props = {
  label: string;
  dataTestId?: string;
  isSelected: boolean;
  onSelect: () => void;
};

export const OptionItem = ({ label, dataTestId, isSelected, onSelect }: Props) => (
  <SOptionRow
    aria-checked={isSelected}
    data-testid={dataTestId}
    isSelected={isSelected}
    role="radio"
    type="button"
    onClick={onSelect}
  >
    <Typography color={isSelected ? 'primary.700' : 'grey.700'} variant="body-2-md">
      {label}
    </Typography>
    <SCheckCircle aria-hidden="true" isSelected={isSelected}>
      {isSelected && <CheckIcon />}
    </SCheckCircle>
  </SOptionRow>
);
